export function resolveSidebarNavTestId(id: string): string {
  if (id.startsWith('sidebar-')) return id

  return `settings-nav-${id}`
}
